// Seedable RNG (mulberry32). The spawner takes an injected Rng so daily
// challenges can replay identical runs from a date-derived seed.

export interface Rng {
  next(): number; // [0, 1)
}

export function mulberry32(seed: number): Rng {
  let a = seed >>> 0;
  return {
    next() {
      a = (a + 0x6d2b79f5) | 0;
      let t = Math.imul(a ^ (a >>> 15), 1 | a);
      t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    },
  };
}

export function randomSeed(): number {
  return (Math.random() * 4294967296) >>> 0;
}

/** Reseedable Rng: systems hold one reference for the app's lifetime while
 *  each run re-seeds it — daily challenges use the date seed so every player
 *  gets the identical spawn sequence. */
export class SeedableRng implements Rng {
  private inner: Rng;

  constructor(seed: number) {
    this.inner = mulberry32(seed);
  }

  next(): number {
    return this.inner.next();
  }

  reseed(seed: number): void {
    this.inner = mulberry32(seed);
  }
}

/** Seed derived from a YYYY-MM-DD date string, for daily challenges. */
export function dateSeed(isoDate: string): number {
  let h = 2166136261 >>> 0;
  for (let i = 0; i < isoDate.length; i++) {
    h ^= isoDate.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  return h >>> 0;
}
